var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignatureIconLarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "83px",
    viewBox: "0 0 83 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#FFCC00",
    cx: 41.5,
    cy: 41.5,
    r: 41.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(14.000000, 18.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.534359,32.1874872 L20.0430769,40.2367179 C19.9671795,40.6469744 20.1497436,41.0654359 20.5046154,41.2890256 C20.8594872,41.5146667 21.3148718,41.4982564 21.6553846,41.2541538 L28.2851282,36.4541538 L21.534359,32.1874872 Z",
    id: "Fill-4864"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4865",
    points: "33.5887179 12.4970256 22.3497436 30.2775385 29.6584615 34.8949744 40.8974359 17.1165128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6377436,11.041641 C49.7208205,9.32676923 49.4356923,7.14010256 48.0859487,5.73702564 L48.4900513,5.09702564 C48.793641,4.61907692 48.6500513,3.98728205 48.1721026,3.68164103 L42.6008205,0.159589744 C42.1208205,-0.144 41.4890256,-0.000410256411 41.1854359,0.477538462 L34.6849231,10.7606154 L41.9915897,15.3821538 L46.9167179,7.58728205 C47.3331282,8.30112821 47.3741538,9.20369231 46.9044103,9.94625641 L39.8582564,21.0970256 C39.5546667,21.5770256 39.7003077,22.2088205 40.1782564,22.5124103 C40.6562051,22.816 41.2900513,22.6724103 41.5915897,22.1924103 L48.6377436,11.041641 Z",
    id: "Fill-4866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1866667,41.3261538 L16.1097436,38.2492308 C15.7097436,37.8492308 15.0594872,37.8492308 14.6594872,38.2492308 L11.2810256,41.625641 L7.90461538,38.2492308 C7.50461538,37.8492308 6.85435897,37.8492308 6.45435897,38.2492308 L0.300512821,44.4030769 C-0.101538462,44.8030769 -0.0994871795,45.4533333 0.300512821,45.8533333 C0.700512821,46.2533333 1.34871795,46.2533333 1.75076923,45.8533333 L7.17846154,40.4235897 L10.5569231,43.8020513 C10.9569231,44.2020513 11.6071795,44.2020513 12.0071795,43.8020513 L15.3835897,40.4235897 L17.7364103,42.7764103 C18.1364103,43.1764103 18.7866667,43.1764103 19.1866667,42.7764103 C19.5866667,42.3764103 19.5866667,41.7261538 19.1866667,41.3261538",
    id: "Fill-4867"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignatureIconLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/signature_icon_large.8b02c3898bc931599c4537ce63fd12b4.svg";